import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=373c5b5a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=373c5b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c5b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373c5b5a')) {
      api.createRecord('373c5b5a', component.options)
    } else {
      api.reload('373c5b5a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=373c5b5a&scoped=true&", function () {
      api.rerender('373c5b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-201V27iL26AVU/JS/teamMember.vue"
export default component.exports